__webpack_require__.p = "https://deo.shopeemobile.com/shopee/shopee-usertob-live-sg/food-driver/assets/";